
import { Auth } from '@andes/auth';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { IPaciente } from '../../../../core/mpi/interfaces/IPaciente';
import { PacienteService } from '../../../../core/mpi/services/paciente.service';
import { DocumentosService } from '../../../../services/documentos.service';
import { IPrestacion } from '../../interfaces/prestacion.interface';
import { populateRelaciones } from '../../operators/populate-relaciones';
import { ElementosRUPService } from '../../services/elementosRUP.service';
import { PrestacionesService } from '../../services/prestaciones.service';
import html2canvas from 'html2canvas';
@Component({
    selector: 'vista-prestacion',
    templateUrl: 'vistaPrestacion.html',
    styleUrls: ['../core/_rup.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class VistaPrestacionComponent implements OnInit {
    @Input() paciente: IPaciente;
    @Input() prestacion: IPrestacion;
    @Input() puedeEditar: boolean;
    @Input() tipo;

    public ready$ = this.elementosRUPService.ready;
    public puedeDescargarInforme: boolean;
    public requestInProgress: boolean;
    public hasPacs: boolean;
    public mostrarMas = false;

    _puedeEditar: boolean;


    constructor(
        private auth: Auth,
        private servicioDocumentos: DocumentosService,
        private servicioPrestacion: PrestacionesService,
        private servicioPaciente: PacienteService,
        private elementosRUPService: ElementosRUPService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.puedeDescargarInforme = this.auth.check('huds:impresion');
        if (this.prestacion) {
            this.hasPacs = this.prestacion.metadata?.findIndex(item => item.key === 'pacs-uid') >= 0;
            populateRelaciones(this.prestacion);
        }
    }

    private _idPrestacion;
    @Input()
    set idPrestacion(value: any) {
        this.paciente = null;
        this.prestacion = null;
        this._idPrestacion = value;
        this.servicioPrestacion.getById(this.idPrestacion).pipe(
            map(prestacion => populateRelaciones(prestacion))
        ).subscribe(prestacion => {
            this.hasPacs = prestacion.metadata?.findIndex(item => item.key === 'pacs-uid') >= 0;
            if (prestacion.paciente?.id) {
                this.servicioPaciente.getById(prestacion.paciente.id).subscribe(paciente => {
                    this.prestacion = prestacion;
                    this.paciente = paciente;
                    this._puedeEditar = this.puedeEditar && this.checkUser();
                });
            }
        });
    }

    get idPrestacion(): any {
        return this._idPrestacion;
    }

    mostrar() {
        this.mostrarMas = !this.mostrarMas;
    }

    getTimestamp(fecha) {
        return fecha.getTime();
    }

    checkUser() {
        const permisoExtra = this.auth.check('rup:validacion:' + this.prestacion.solicitud.tipoPrestacion.id);
        return permisoExtra || this.prestacion.createdBy.id === this.auth.usuario.id;
    }

    async descargarInforme() {
        this.requestInProgress = true;
        const term = this.prestacion.solicitud.tipoPrestacion.term;
        const informe: any = { idPrestacion: this.prestacion.id };

        // Capturamos snapshots de los odontogramas si existen
        const odontogramas = document.querySelectorAll('rup-OdontogramaRefset');
        if (odontogramas.length > 0) {
            const snapshots = {};
            for (const el of Array.from(odontogramas)) {
                const card = el.closest('.rup-card');
                const registroId = card?.getAttribute('data-id');

                if (registroId) {
                    try {
                        const canvas = await html2canvas(el as HTMLElement, {
                            logging: false,
                            backgroundColor: '#ffffff'
                        });
                        snapshots[registroId] = canvas.toDataURL('image/png');
                    } catch (e) {
                    }
                }
            }
            informe.snapshots = snapshots;
        }

        this.servicioDocumentos.descargarInformeRUP(informe, term).subscribe(
            () => this.requestInProgress = false,
            () => this.requestInProgress = false
        );
    }

    onPacs() {
        this.servicioPrestacion.visualizarImagen(this.prestacion);
    }

    abrirPrestacion() {
        this.servicioPrestacion.notificaRuta({
            // Generico por ahora
            nombre: 'VOLVER',
            ruta: this.router.url
        });
        this.router.navigate(['./rup/ejecucion', this.prestacion.id]);
    }

    get tieneOdontograma() {
        return this.prestacion?.ejecucion?.registros?.some(r => r.concepto.conceptId === '3561000013109');
    }

}
